(function() {
  function isMobile() {
    return (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) ||
      /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent) ||
      (navigator.maxTouchPoints > 0 && screen.width <= 1180);
  }

  function normalizeFilters(container) {
    var filter = document.getElementById('collectionTopFilter');
    if (!filter || !container) return;
    filter.classList.add('bgtcg-mobile-filter-fixed');
  }

  function applyFilters() {
    if (typeof window.applyFilters === 'function') {
      window.applyFilters();
    }
  }

  function buildRaritySections() {
    if (!isMobile()) return;
    var container = document.getElementById('ProductGridContainer');
    if (!container || container.querySelector('.bgtcg-js-rarity-section')) return;
    normalizeFilters(container);

    var grid = container.querySelector('ul.product-grid');
    if (!grid || grid.classList.contains('bgtcg-rarity-grouped')) return;
    var items = Array.prototype.slice.call(grid.children).filter(function(item) {
      return item.classList && item.classList.contains('grid__item') && item.hasAttribute('data-rarity');
    });
    if (!items.length) return;

    var hasSingleCards = items.some(function(item) {
      return item.querySelector('.product-card-wrapper:not(.bgtcg-non-single-card)');
    });
    if (!hasSingleCards) return;

    var orderedRarities = Array.prototype.slice.call(document.querySelectorAll('#rarityFilterBtns button[data-rarity]'))
      .map(function(button) { return button.getAttribute('data-rarity'); })
      .filter(function(rarity) { return rarity && rarity !== 'all'; });
    var buckets = {};
    items.forEach(function(item) {
      var rarity = item.getAttribute('data-rarity') || '其他';
      if (!buckets[rarity]) buckets[rarity] = [];
      buckets[rarity].push(item);
    });
    Object.keys(buckets).forEach(function(rarity) {
      if (orderedRarities.indexOf(rarity) === -1) orderedRarities.push(rarity);
    });

    var fragment = document.createDocumentFragment();
    orderedRarities.forEach(function(rarity) {
      var rarityItems = buckets[rarity];
      if (!rarityItems || !rarityItems.length) return;
      var section = document.createElement('div');
      section.className = 'rarity-section bgtcg-js-rarity-section';
      section.setAttribute('data-rarity', rarity);

      var title = document.createElement('h2');
      title.className = 'rarity-title';
      title.innerHTML = rarity + ' <span class="rarity-count">(' + rarityItems.length + ')</span>';

      var sectionGrid = grid.cloneNode(false);
      sectionGrid.classList.add('bgtcg-rarity-grouped');
      rarityItems.forEach(function(item) {
        sectionGrid.appendChild(item);
      });

      section.appendChild(title);
      section.appendChild(sectionGrid);
      fragment.appendChild(section);
    });

    if (!fragment.childNodes.length) return;
    grid.replaceWith(fragment);
    applyFilters();
  }

  function init() {
    buildRaritySections();
    setTimeout(buildRaritySections, 400);
    setTimeout(buildRaritySections, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
